import { Pipe, PipeTransform } from '@angular/core';
import { ColorHelperService } from '../services';


@Pipe({
    name: 'contrastTextColor',
    standalone: false
})

export class ContrastTextColorPipe implements PipeTransform {
  constructor(private readonly colorHelperService: ColorHelperService) { }

  transform(value: string): string {
    if (!value) {
      return;
    }
  
    return this.colorHelperService.getContrastingTextColor(value);
  }
}